import { useState } from "react";
import useElevatorShow from "@/domains/estate/hooks/useElevatorShow";
import { ElevatorControlPanel } from "@/domains/estate/components/elevator/ElevatorControlPanel";

function EstateElevatorContainer() {
  const [targetFloor, setTargetFloor] = useState<number | null>(null);
  const { show, floors, floorTransit, currentFloor, level } = useElevatorShow();

  if (!show) {
    return null;
  }

  return (
    <div className="absolute bottom-[--boundary-offset-y] right-[--boundary-offset-x]">
      <ElevatorControlPanel
        targetFloor={targetFloor}
        currentFloor={currentFloor}
        level={level}
        floors={[1, ...floors]}
        onTargetFloorChange={(floor) => {
          setTargetFloor(floor);
          setTimeout(() => {
            floorTransit(floor);
          }, 2000);
        }}
        size="sm"
      />
    </div>
  );
}

export default EstateElevatorContainer;
